<template>
  <v-row no-gutters>
    <v-col
      class="border header-text"
      cols="12"
      :style="{
        backgroundColor: PAYMENT_CERTIFICATE_TABLE_COLOR.BLUE
      }"
    >
      <h3 class="pa-2">{{ title }}</h3>
    </v-col>
  </v-row>
</template>

<script>
import { PAYMENT_CERTIFICATE_TABLE_COLOR } from '@/helpers'

export default {
  props: {
    title: String
  },
  data () {
    return {
      PAYMENT_CERTIFICATE_TABLE_COLOR
    }
  }
}
</script>
